import React from 'react'
import classNames from 'classnames'
import { string, object } from 'prop-types'
import defaultTranslationConfig from '../../../config/components/productList/uk/'

// This are used to populate the caveat at the bottom of the table
let startDate
let endDate
let dateUsed

class productList extends React.Component {
  getTranslationConfig () {
    const { domainSettings: { language = 'UK' } } = this.props
    if (language !== 'UK') {
      const translationConfig = require(`../../../config/components/productList/${language.toLowerCase()}/`)
      return translationConfig
    }
    return defaultTranslationConfig
  }

  getType (productClass) {
    if (productClass === 'HCP' || productClass === 'HO') return 'hotelLocations'
    if (productClass === 'LO') return 'loungesLocations'
    return 'parkingLocations'
  }

  getTableDataFromFeed () {
    const { location, pageData: { productClass }, terminal } = this.props
    const allowedColumns = {
      'HO': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        starRating: true,
        rating: true,
        distance: true,
        transfers: true
      },
      'HCP': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        starRating: true,
        rating: true,
        distance: true,
        transfers: true
      },
      'LO': {
        title: true,
        starRating: true,
        times: true,
        rating: true,
        lowestPrice: true,
        logo: true
      },
      'CP': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        distance: true,
        transfers: true,
        rating: true
      }
    }
    try {
      const type = this.getType(productClass.toUpperCase())
      let data = require('../../../../config/exports/buildTimeOnly/' + type + '/' + location.code + (terminal.length > 0 ? '_' + terminal : '') + '.json')
      data = this.getItemData(data, type)
      return this.makeItem(data, allowedColumns[productClass])
    } catch (e) {}
  }

  // Create each table row object how we need it
  getItemData (tableData, type) {
    const { domainSettings: { contentStaticServer } } = this.props
    const excludedCodes = [
      'STNHIR',
      'STNHIL',
      'STNHRH',
      'STNHIP'
    ]
    const output = [ ]
    Object.keys(tableData).map(key => {
      const item = tableData[key]
      if (!item.prodlib) return
      let {
        tripappcarparkname,
        tripapphotelname,
        tripappaddonname,
        name,
        on_airport: onAirport,
        address,
        transfer_time: transferTime,
        transfers_included_in_price: transfersIncludedInPrice,
        free_transfers: freeTransfers,
        transfer_price: transferPrice,
        distance_miles: distanceMiles,
        meet_and_greet: meetAndGreet,
        wistia_key: wistiaKey,
        openingtime: openingTime,
        closingtime: closingTime,
        _prodcode,
        logo,
        tripappimages,
        brand_image: brandImage,
        seo_optimised_brand_image_300_200: seoOptimisedImage,
        exclude_from_seo_table: excludeFromSeoTable
      } = item.prodlib

      if (excludedCodes.indexOf(_prodcode) > -1) return

      const productName = tripappcarparkname || tripapphotelname || tripappaddonname || item.title || item.browserTitle || name
      const pageName = item.pagename && item.pagename.replace('"', '')
      onAirport = parseInt(onAirport, 10)

      let transferText = 'Transfer not required'
      if (transferTime) {
        transferText = transferTime + ' minute transfer'
      } else if (transfersIncludedInPrice || freeTransfers || (transferPrice && (/FREE/gi).test(transferPrice))) {
        transferText = 'Transfer included'
      }

      const distanceUnits = parseFloat(distanceMiles).toFixed(1)
      let distanceText = distanceUnits + ' miles from the airport'
      if (!distanceMiles) distanceText = false
      if (parseInt(meetAndGreet, 10)) {
        distanceText = 'Located on airport'
      } else if (onAirport) {
        distanceText = 'Located on airport'
      }

      let perDayPrice, perWeekPrice, lowestPrice
      if (item.price) {
        if (item.price.startDate) startDate = item.price.startDate
        if (item.price.endDate) endDate = item.price.endDate
        if (item.price.dateUsed) dateUsed = item.price.dateUsed
        lowestPrice = item.price.lowestPrice
        perDayPrice = item.price.per_day || item.price.lowestDays0
        perWeekPrice = item.price.per_week || item.price.lowestDays8
      }
      const perDayUnits = perDayPrice || '0.00'
      const perWeekUnits = perWeekPrice || '0.00'

      let starRatingOutput = false
      const tempArray = Array.apply(null, {length: item.prodlib.star_rating}).map(Number.call, Number)
      starRatingOutput = tempArray.map((key) => {
        return (
          <i key={key} className='fa fa-star' />
        )
      })

      logo = logo && contentStaticServer ? logo.replace(/\/(libraryimages|imageLibrary)/g, contentStaticServer + '/libraryimages') : false
      brandImage = brandImage && contentStaticServer ? brandImage.replace(/\/(libraryimages|imageLibrary)/g, contentStaticServer + '/libraryimages') : false
      seoOptimisedImage = seoOptimisedImage && contentStaticServer ? seoOptimisedImage.replace(/\/(libraryimages|imageLibrary)/g, contentStaticServer + '/libraryimages') : false
      let heroImage = tripappimages && contentStaticServer ? tripappimages.split(';')[0].replace(/\/(libraryimages|imageLibrary)/g, contentStaticServer + '/libraryimages') : false

      output.push({
        productName,
        _prodcode,
        pageName,
        linkTitle: item.title || name,
        address: address && address.replace(/(<br \/>|<br>|<br\/>)/g, ' '),
        extraLinks: item.links,
        score: item.score,
        starRating: item.prodlib.star_rating,
        starRatingOutput,
        wistiaKey,
        transferText,
        distanceUnits,
        distanceText,
        openingTime,
        closingTime,
        perDayPrice,
        perWeekPrice,
        perDayUnits,
        perWeekUnits,
        lowestPrice,
        logo,
        type,
        heroImage,
        brandImage,
        seoOptimisedImage,
        excludeFromSeoTable
      })
      return key
    })
    return output
  }

  getRatingText (score = 0) {
    if (score >= 90) return 'Excellent'
    if (score >= 70) return 'Good'
    if (score >= 50) return 'Average'
    return 'Poor'
  }

  createPerDayPerWeekClass (perDay = true, grey) {
    return classNames({
      'perDay': perDay,
      'perWeek': !perDay,
      'col-xs-6': true,
      'col-md-12': true,
      'grey': grey,
      'invisible': grey
    })
  }

  createPriceSection (item, allowedColumns) {
    const { setVar = { } } = this.props
    const perDayClass = this.createPerDayPerWeekClass(true, !item.perDayPrice)
    const perWeekClass = this.createPerDayPerWeekClass(false, !item.perWeekPrice)
    const lowestPriceOnlyClass = classNames({
      'lowestPriceOnly': true,
      'col-xs-6': true,
      'col-md-12': true,
      'grey': true
    })
    const noPrice = (<span className='small'>-- --</span>)
    const perDayCaveat = item.perDayPrice ? '*' : '**'
    const perWeekCaveat = item.perWeekPrice ? '*' : '**'
    const lowestPriceOnlyCaveat = item.lowestPrice ? '*' : '**'
    const perDayPriceLabel = item.type === 'parkingLocations' ? 'Per day' : 'Room only'
    const perWeekPriceLabel = item.type === 'parkingLocations' ? 'Per week' : 'With parking'
    const { lowestPriceOnlyLabel, thisIsAGuidePriceOnlyText } = this.getTranslationConfig()
    const buttonText = !item.perDayPrice && !item.perWeekPrice && !item.lowestPrice ? 'Search for price' : 'More info'
    item.perDayPrice = item.perDayPrice || noPrice
    item.perWeekPrice = item.perWeekPrice || noPrice
    item.lowestPrice = item.lowestPrice || noPrice
    const lowestPriceOnly = !allowedColumns.perDayPrice && !allowedColumns.perWeekPrice && allowedColumns.lowestPrice
    return (
      <div className='col-xs-8 col-md-2 col-lg-3 price-container'>
        { allowedColumns.perDayPrice && !setVar.hideTablePrices && (
          <div className={perDayClass}>
            <span className='d-block tiny-xs small text-muted col-lg-6'>{perDayPriceLabel}</span>
            <a href={item.pageName} className='m-0 tableTooltip col-lg-6' title={thisIsAGuidePriceOnlyText}>&pound;{ item.perDayPrice }<span className='small p-0'>{perDayCaveat}</span></a>
          </div>
        )}
        { allowedColumns.perWeekPrice && !setVar.hideTablePrices && (
          <div className={perWeekClass}>
            <span className='d-block tiny-xs small text-muted col-lg-6'>{perWeekPriceLabel}</span>
            <a href={item.pageName} className='m-0 tableTooltip col-lg-6' title={thisIsAGuidePriceOnlyText}>&pound;{ item.perWeekPrice }<span className='small p-0'>{perWeekCaveat}</span></a>
          </div>
        )}
        {/* For lounges */}
        { lowestPriceOnly && !setVar.hideTablePrices && (
          <div className={lowestPriceOnlyClass}>
            <span className='d-block tiny-xs small text-muted col-lg-5'>{lowestPriceOnlyLabel}</span>
            <a href={item.pageName} className='m-0 tableTooltip col-lg-7' title={thisIsAGuidePriceOnlyText}>
              &pound;{ item.lowestPrice }
              <span className='small p-0'>{lowestPriceOnlyCaveat}</span>
            </a>
          </div>
        )}
        <div className='col-md-12 text-center block-xs hidden-xs hidden-sm'>
          <a href={item.pageName} title={item.linkTitle} className='btn btn-block btn-sm btn-primary small-sm small-xs purple'>{ buttonText }</a>
        </div>
      </div>
    )
  }

  createImageSection (item) {
    const { domainSettings: { contentStaticServer }, pageData } = this.props
    let logo = false
    const mysteryHotel = contentStaticServer + '/images/holidayextras/mystery-hotel.jpg'
    const noImage = 'https://d17s4kc6349e5h.cloudfront.net/holidayextras/assets/images/hx-logo-web@2x.png'
    logo = item.productName.search(/mystery/i) !== -1 ? mysteryHotel : item.seoOptimisedImage || item.brandImage || item.heroImage || item.logo || noImage
    const logoSrc = logo.replace(/\s/g, '')
    const fullMobileWithImages = pageData.pageName === 'edinburgh-airport-hotels'
    const imageContainerClass = classNames({
      'col-xs-12': fullMobileWithImages,
      'col-xs-4': !fullMobileWithImages,
      'col-sm-4': fullMobileWithImages,
      'col-md-3': true,
      'image-container': true,
      'p-0': true
    })
    return (
      <div className={imageContainerClass}>
        <a href={item.pageName} title={item.linkTitle}>
          <img data-original={logoSrc} />
        </a>
        <ul className='small text-muted list-unstyled list-inline mb-0'>
          { item.extraLinks && item.extraLinks.directions && (
            <li>
              <i className='fa fa-fw fa-map-marker text-faded' /><a className='tiny' href={'/' + item.extraLinks.directions + '.html'} title='Directions'>Directions</a>
            </li>
          )}
          { item.extraLinks && item.extraLinks.photos && (
            <li>
              <i className='fa fa-fw fa-photo text-faded' /><a className='tiny' href={'/' + item.extraLinks.photos + '.html'} title='Photos'>Photos</a>
            </li>
          )}
          { item.wistiaKey && (
            <li>
              <i className='fa fa-fw fa-youtube-square text-faded' /><a href='#' data-newwindow={'https://fast.wistia.net/embed/iframe/' + item.wistiaKey + '?autoPlay=true&controlsVisibleOnLoad=true&playButton=false&playerColor=F36F36&popover=true&version=v1&videoHeight=180&videoWidth=320'} className='wistia-popover[height=180,playerColor=7b796a,width=320] tiny' title='video'>Video</a>
            </li>
          )}
        </ul>
      </div>
    )
  }

  createItemMainContent (item = { }, allowedColumns) {
    const reviewsLink = (item.extraLinks && item.extraLinks.reviews) ? `/${item.extraLinks.reviews}.html` : 'javascript:void(0)'
    const score = item.score && item.score.averageAsPercentage
    const noPrices = !item.perWeekPrice && !item.perDayPrice
    const reviewsClass = classNames({
      'rating-link': true,
      'tableTooltip': true,
      'reviewsTag' : reviewsLink.indexOf('javascript') > -1
    })
    const contentContainerClass = classNames({
      'col-xs-8': true,
      'col-md-7': !noPrices,
      'col-lg-6': !noPrices,
      'col-md-9': noPrices,
      'content-container': true
    })
    const ratingClass = classNames({
      'label': true,
      'label-fixed-ratio': true,
      'product-rating-higher': score >= 90,
      'product-rating-high': score < 90 && score >= 70,
      'product-rating-low': score < 70 && score >= 50,
      'product-rating-lower': score < 50
    })
    const ratingText = this.getRatingText(score)
    return (
      <div className={contentContainerClass}>
        <div className='col-xs-12 inner-info-container'>
          <h3 className='product-title'><a href={item.pageName} title={item.linkTitle}>{ item.productName }</a></h3>
          <ul className='col-xs-12 list-unstyled list-inline text-muted product-features small p-0 m-0'>
            { allowedColumns.distance && item.distanceText !== false && (
              <li>
                <i className='fa fa-fw fa-map-marker text-faded' /> { item.distanceText }
              </li>
            )}
            { allowedColumns.transfers && (
              <li>
                <i className='fa fa-fw fa-bus text-faded' /> { item.transferText }
              </li>
            )}
          </ul>
          { allowedColumns.rating && item.score.averageAsPercentage !== 0 && (
            <div className='reviews-score-container col-xs-6 '>
              <a className={reviewsClass} href={reviewsLink} data-toggle='tooltip' data-placement='top' title={item.score.averageAsPercentage + '% of ' + item.score.reviewed + ' guests said they would book again.'} rel={item.score.reviewed}>
                <div className='small-xs small-sm pull-left rating-container'>
                  <span className={ratingClass}>{item.score.averageAsPercentage / 10}</span>
                </div>
                <span className='hidden-sm hidden-xs rating-text text-default small'>{ratingText}</span>
                <span className='small tiny-xs review-count'>{item.score.reviewed.toLocaleString()} reviews</span>
              </a>
            </div>
          )}
          <div className='stars col-xs-6'>
            { item.starRatingOutput !== false && item.starRatingOutput }
          </div>
        </div>
      </div>
    )
  }

  makeItem (items = [ ], allowedColumns) {
    return items.map((item, key) => {
      if (item.excludeFromSeoTable) return null
      const priceSection = this.createPriceSection(item, allowedColumns)
      const imageSection = this.createImageSection(item)
      const mainContent = this.createItemMainContent(item, allowedColumns)

      return (
        <div className='panel product-item panel-default clearfix' key={key} data-productcode={item._prodcode}>
          <div className='panel-body p-0'>
            {imageSection}
            {mainContent}
            {priceSection}
          </div>
        </div>
      )
    })
  }

  render () {
    const { id, pageData } = this.props
    const items = this.getTableDataFromFeed()

    if (!items) {
      return (
        <span id={id} />
      )
    }

    return (
      <div id={id} className='product-list-full'>
        { items }
        { pageData.pageName !== 'humberside-airport-parking' && pageData.productClass.toUpperCase() === 'CP' && (
          <p>*This is an example price for reservations between { startDate } and { endDate }, valid as of { dateUsed }.  The price per week is the total cost of this car parking for 8 days. The price per day refers to the same product and period, divided by 8.</p>
        )}
        { pageData.productClass.toUpperCase() !== 'CP' && (
          <div className='caveat-text'>
            <p>*This is an example price for a reservation on { startDate }, valid as of { dateUsed }.</p>
          </div>
        )}
      </div>
    )
  }
}

productList.defaultProps = {
  terminal: ''
}

productList.propTypes = {
  id: string.isRequired,
  terminal: string,
  pageData: object,
  location: object,
  setVar: object,
  domainSettings: object
}

export default productList



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/productList.jsx